<div [formGroup]="formGroup">
  <tui-radio-list
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    [size]="size"
    [items]="items"
    [itemContent]="itemContentTemplate"
    [orientation]="orientation"
    [disabledItemHandler]="disabledItemHandler"
    (focusedChange)="handleFocusedChange($event)"
  >
    <ng-template
      #itemContentTemplate
      tuiRadioList
      let-item
    >
      <div class="radio-list-container">
        <div>{{ item.label }}</div>
        <div
          *ngIf="item?.description.length > 0"
          class="description"
          [innerHtml]="item.description | kwikuiSafeHtml"
        ></div>
      </div>
    </ng-template>
  </tui-radio-list>
</div>
